module.exports = __webpack_public_path__ + "img/order_none.165020cd.png";